import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SessionCredits } from "@/components/SessionCredits";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Award } from "lucide-react";

export default function MyPrizes() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/credits/mine").then((r) => setData(r.data))
    .catch(() => setData({ credits: [], invites: [], available: 0 })), []);
  useEffect(() => { if (user) load(); }, [user, load]);

  if (!user) {
    return (
      <div className="max-w-md mx-auto px-4 py-20 text-center" data-testid="prizes-login-required">
        <Award className="w-10 h-10 mx-auto mb-3 text-primary" />
        <h1 className="text-2xl font-extrabold">Mis créditos</h1>
        <Button asChild className="mt-6"><Link to="/login?next=/mis-creditos">Iniciar sesión</Link></Button>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="my-prizes-page">
      <h1 className="text-3xl font-extrabold tracking-tight flex items-center gap-3 flex-wrap">
        Mis créditos
        {data && <Badge className="tracking-normal" data-testid="credits-available-count">{`${data.available} disponible${data.available === 1 ? "" : "s"}`}</Badge>}
      </h1>
      <SessionCredits data={data} onChanged={load} />
    </div>
  );
}
